import React from 'react';
import {
  ColorSwatch,
  type IColorInfo,
} from '@/pages/datalab/components/ColorPalette';
import ColorPalettePopover from '@/pages/datalab/components/ColorPalettePopover';
import { useIntl } from 'umi';
import './index.scss';
import { Button, Icon } from 'tea-component';

interface ITextBackgroundColorSettingProps {
  value?: IColorInfo;
  onChange: (color: IColorInfo) => void;
  popupContainer?: () => HTMLElement;
}

const DEFAULT_COLOR: IColorInfo = { hexa: '#ffffff', alpha: '100' };
const TEXT_BG_PRESET_COLORS: string[] = [
  '#ffffff',
  '#00000000',
  '#f2f3f5',
  '#d8dae4',
  '#838697',
  '#262832',
  '#326ff0',
  '#57b8ff',
  '#13bf4f',
  '#f3ae2f',
  '#f05858',
  '#8e59ff',
  '#ff5cad',
  '#00bfbf',
];

const TextBackgroundColorSetting: React.FC<ITextBackgroundColorSettingProps> = (props) => {
  const { value, onChange, popupContainer } = props;
  const { formatMessage } = useIntl();

  const currentColor = value || DEFAULT_COLOR;
  const isTransparentColor = currentColor.alpha === '0';
  const swatchColor = isTransparentColor ? '#00000000' : currentColor.hexa;

  return (
    <div className="dbl-text-bg-color-setting">
      
      <h5 className="dbl-text-bg-color-setting-label">{formatMessage({ id: 'dbl_create_dashboard_text_background_color' })}</h5>
      
      <ColorPalettePopover
        value={currentColor}
        onChange={onChange}
        colorProps={{
          className: 'dbl-text-bg-color-setting-palette',
          presetColors: TEXT_BG_PRESET_COLORS,
        }}
        popoverProps={{
          trigger: 'click',
          placement: 'bottom-end',
          positionFixed: false,
          popupContainer,
        }}
      >
        <div className="dbl-text-bg-color-setting-swatch-container">
          <ColorSwatch
            className="dbl-text-bg-color-setting-swatch"
            color={swatchColor}
            size={23}
            borderRadius={4}
            showBorder={swatchColor?.toLowerCase() === '#ffffffff'}
          />
          <Icon type="arrowdown" />
        </div>
       </ColorPalettePopover>
    </div>
  );
};

export default TextBackgroundColorSetting;
